import useSWR from 'swr';
import denApi from '@/lib/api/denApi';
import { useAuthClient } from '@/lib/authClient';

type MobileTokenResponse = { token: string };

const createFetcher =
  (email: string, signIn: ReturnType<typeof useAuthClient>['signIn']) =>
  async (): Promise<MobileTokenResponse> => {
    // Step 1: trigger Better Auth magic-link generation via the Better Auth client
    await signIn.magicLink({ email });
    // Step 2: fetch the token from backend (server waits up to 5s)
    return await denApi.get<MobileTokenResponse, void>('link-device/qr-code');
  };

export function useMobileToken() {
  const { user, signIn } = useAuthClient();
  const email = user?.email as string;

  const { data, error, isLoading, mutate } = useSWR(
    'link-device/qr-code',
    // Avoid calling hook in createFetcher since it isn't at the top level.
    createFetcher(email, signIn),
    {
      revalidateOnFocus: false,
      refreshInterval: 50000,
    }
  );

  return {
    token: data?.token ?? '',
    error,
    isLoading,
    refresh: mutate,
  };
}
